app.directive('tagsWithDropdown', ['$filter', '$rootScope', '$timeout', function($filter, $rootScope, $timeout){
    return {
        restrict: 'A',
        scope:true,
        link:function(scope, element, attrs){
            scope.showItems = true;
            var update = function(){
                $timeout(
                    function(){
                        var parent = $(element[0]);
                        var items = $(element[0]).find('[item]');
                        var nbItemHide = 0;

                        $.each(items, function(index, item){
                            if(!checkOutside(parent[0], item)) {
                                nbItemHide++;
                            }
                        });

                        if(nbItemHide <= 0 && scope.showItems === false) {
                            scope.showItems = true;
                        } else if(nbItemHide > 0 && scope.showItems === true){
                            scope.showItems = false;
                        }
                    }
                )
            };
            update();
            $rootScope.$on('windowResize', update);
            function checkOutside(parentDiv, childDiv) {
                var parentRect = parentDiv.getBoundingClientRect();
                var childRect = childDiv.getBoundingClientRect();

                return parentRect.left <= childRect.left && parentRect.right >= childRect.right;
            }
        }
    }
}]);